import React, {useState, useEffect, createContext} from "react";
import axios from "./axios";

const BrandContext = createContext([{}, () => {}]);

const BrandProvider = props => {
    const {children} = props;
    const [brandConfig, setBrandConfig] = useState();
    const loadBrandConfig = () => {
        axios.get('/web/ui/session/public/brandConfig')
            .then(response => {
                setBrandConfig(response.data);
            });
    }

    useEffect(() => {
        loadBrandConfig();
    }, []);

    return (
        <BrandContext.Provider value={brandConfig}>
            {children}
        </BrandContext.Provider>
    );
}

export {BrandContext, BrandProvider};